module.exports = __webpack_public_path__ + "img/pricing-banner-graphics.c4fcbe29.svg";